import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-153ae893"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-socials" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-socials__title" }, " Socials ", -1))
const _hoisted_3 = { class: "footer-socials__links" }
const _hoisted_4 = ["src"]

import BaseLink from '@/components/BaseLink.vue'
import { linkTo } from '@/constants'

type SocialLink = {
  to: string
  title: string
  icon: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterSocials',
  setup(__props) {

const socialLinks: SocialLink[] = [{
  to: linkTo.discord,
  title: 'PWN on Discord',
  icon: '/discord.svg',
}, {
  to: linkTo.twitter,
  title: 'PWN on Twitter',
  icon: '/twitter.svg',
}, {
  to: linkTo.youtube,
  title: 'PWN on Youtube',
  icon: '/youtube.svg',
}, {
  to: linkTo.blog,
  title: 'PWN on mirror.xyz',
  icon: '/mirror.svg',
}, {
  to: linkTo.instagram,
  title: 'PWN on Instagram',
  icon: '/instagram.svg',
}, {
  to: linkTo.linkedIn,
  title: 'PWN on LinkedIn',
  icon: '/linkedin.svg',
}]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialLinks, (link) => {
        return _createVNode(BaseLink, {
          key: link.to,
          to: link.to,
          target: "_blank",
          title: link.title
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "footer-socials__icon",
              src: link.icon,
              alt: "social icon"
            }, null, 8, _hoisted_4)
          ]),
          _: 2
        }, 1032, ["to", "title"])
      }), 64))
    ])
  ]))
}
}

})